import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { FreightBookingDetailState } from '../../../BookingWizardData/FreightBookingWizardData';

export const confirmDeleteFreightItem = async (state: FreightBookingDetailState) => {
	try {
		if (shouldConfirmDeletion(state)) {
			await newConfirmModal('Discard Changes?', "This action can't be undone.", {
				confirmText: 'Delete',
				cancelText: 'Keep',
			});
		}
		return true;
	} catch {
		// user did not confirm delete, no action required
		return false;
	}
};

const shouldConfirmDeletion = ({
	freightCategoryId,
	freightTypeId,
	handlingIds,
	quantity,
	weight,
	width,
	height,
	length,
	description,
	addOns,
}: FreightBookingDetailState) => {
	if (freightCategoryId) {
		return true;
	}
	if (freightTypeId) {
		return true;
	}
	if (handlingIds.length > 0) {
		return true;
	}
	if (quantity) {
		return true;
	}
	if (weight) {
		return true;
	}
	if (width) {
		return true;
	}
	if (height) {
		return true;
	}
	if (length) {
		return true;
	}
	if (description) {
		return true;
	}
	if (addOns.length > 0) {
		return true;
	}
	return false;
};
